//获取url地址问号后面的参数列表
export const urlParams = (search?: string): any  => {
  /* eslint-disable no-param-reassign */
  search = search || window.location.search;
  search = search.split('?')[1];
  if(!search) {
    return {}
  }
  const urlParams = search.split('&');
  let values = {}
  urlParams.forEach((element: any) => {
    const item = element.split('=');
    values[item[0]] = item[1]
  });
  return values;
}

//获取url地址问号后面的参数列表
export function getUrlParams<T extends readonly string[], R = Record<T[number], string | null>>(keys: T, search?: string): R;
export function getUrlParams(keys: any, search?: string): null;
export function getUrlParams(keys: any, search?: string): any {
  if(!Array.isArray(keys)) {
    return null;
  }

  /* eslint-disable no-param-reassign */
  search = search || window.location.search;
  search = search.split('?')[1];
  /* eslint-enable no-param-reassign */

  const _urlParams = typeof search === 'string' ? search.split('&') : [];
  const values = keys.reduce((obj, key) => {
    obj[key] = null;
    return obj;
  }, {});
  _urlParams.forEach(str => {
    const i = keys.findIndex(key => str.indexOf(key + '=') === 0);
    if(i !== -1) {
      values[keys[i]] = str.slice(
        str.indexOf('=') + 1
      );
    }
  });
  return values;
}

